import jwtdecode from 'jwt-decode';
// import { BOSC_ID } from './envVariables';

// export const isLoggedIn = () => {
//   let redux = localStorage.getItem('redux');
//   redux = redux ? JSON.parse(redux) || '' : '';
//   if (redux && redux?.login?.token) {
//     return true;
//   }
//   return false;
// };
export const isLoggedIn = () => {
  let redux = localStorage.getItem('redux');
  redux = redux ? JSON.parse(redux) || '' : '';
  let decodedToken;
  if (redux?.login?.token) {
    decodedToken = jwtdecode(redux?.login?.token);
  }
  if (redux && redux?.login?.token && decodedToken?.exp * 1000 - Date.now() > 0) {
    return true;
  }
  return false;
};

export const resetLocalStorage = () => {
  localStorage.clear();
};

export const getReduxData = () => {
  const redux = JSON.parse(localStorage.getItem('redux') || '{}');
  const jwtToken = redux?.login?.token || undefined;
  return { jwtToken };
};
export const isAdmin = () => {
  let redux = localStorage.getItem('redux');
  redux = redux ? JSON.parse(redux) || '' : '';
  if (redux && redux?.login?.user?.userRoleId === 1) {
    return true;
  }
  return false;
};

export const isProjectQaReportPlannedVsActual = () => {
  let redux = localStorage.getItem('redux');
  redux = redux ? JSON.parse(redux) || '' : '';
  if ((redux && redux?.login?.user?.id === 27) || redux?.login?.user?.id === 229) {
    return true;
  }
  return false;
};

export const isStakeholder = () => {
  let redux = localStorage.getItem('redux');
  redux = redux ? JSON.parse(redux) || '' : '';
  if (redux && redux?.login?.user?.userRoleId === 4) {
    return true;
  }
  return false;
};

export const isClient = () => {
  let redux = localStorage.getItem('redux');
  redux = redux ? JSON.parse(redux) || '' : '';
  if (redux && redux?.login?.user?.userRoleId === 5) {
    return true;
  }
  return false;
};


// export const isBOSC = () => {
//   let redux = localStorage.getItem('redux');
//   redux = redux ? JSON.parse(redux) || '' : '';
//   if (redux && redux?.login?.user?.companyId === BOSC_ID) {
//     return true;
//   }
//   return false;
// };
export const isManager = () => {
  let redux = localStorage.getItem('redux');
  redux = redux ? JSON.parse(redux) || '' : '';
  if (redux && redux?.login?.user?.userRoleId === 2) {
    return true;
  }
  return false;
};

export const isHR = () => {
  let redux = localStorage.getItem('redux');
  redux = redux ? JSON.parse(redux) || '' : '';
  if (redux && redux?.login?.user?.userRoleId === 6) {
    return true;
  }
  return false;
};

export const isSuperAdmin = () => {
  let redux = localStorage.getItem('redux');
  redux = redux ? JSON.parse(redux) || '' : '';
  if (redux && redux?.login?.user?.userRoleId === 7) {
    return true;
  }
  return false;
};

export const commonLogoutFunc = () => {
  resetLocalStorage();
};

export const ExemptedEndpoints = [];

export const removeDuplicatesFrmoArray = (arr) => {
  const uniqueIds = [];
  const unique = arr.filter((element) => {
    const isDuplicate = uniqueIds.includes(element.id);
    if (!isDuplicate) {
      uniqueIds.push(element.id);
      return true;
    }
    return false;
  });
  return unique;
};

export const checkComponentPermission = (permission) => {
  let redux = localStorage.getItem('redux');
  redux = redux ? JSON.parse(redux) || '' : '';
  if (redux && redux?.login?.user?.permissions?.includes(permission)) {
    return true;
  }
  return false;
};
